import { z } from 'zod';

/** Internal Search-to-Authority stamp. Never a browser-selected capability. */
export const MarketplaceSearchRepresentationSchema = z.object({
  currentVersion: z.number().int().min(1).max(2_147_483_647),
  sourceRevision: z.string().regex(/^(0|[1-9][0-9]{0,18})$/).refine(
    value => /^(0|[1-9][0-9]{0,18})$/.test(value) && BigInt(value) <= 9_223_372_036_854_775_807n,
    'Source revision is outside the database range',
  ),
  safetyFingerprint: z.string().regex(/^[a-f0-9]{64}$/),
}).strict();

export const MarketplaceSearchCardReferenceSchema = MarketplaceSearchRepresentationSchema.extend({
  candidateId: z.string().uuid(),
});

/** Acquisition is separate from the current public representation on a card. */
export const MarketplaceSearchAcquisitionSchema = z.object({
  kind: z.enum(['none', 'tenant', 'marketplace']),
  dataVersion: z.number().int().min(1).max(2_147_483_647).nullable(),
  currentVersion: z.number().int().min(1).max(2_147_483_647),
}).strict().superRefine((value, ctx) => {
  if ((value.kind === 'none') !== (value.dataVersion === null)) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Access kind and version disagree' });
  }
  if (value.dataVersion !== null && value.dataVersion > value.currentVersion) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Access version is ahead of the current profile' });
  }
});


export type MarketplaceSearchRepresentation = z.infer<typeof MarketplaceSearchRepresentationSchema>;
export type MarketplaceSearchCardReference = z.infer<typeof MarketplaceSearchCardReferenceSchema>;
export type MarketplaceSearchAcquisition = z.infer<typeof MarketplaceSearchAcquisitionSchema>;
